import { Alert } from 'antd';
import React from 'react';

import * as widgetBlocksDefinitions from '../AllWidgetBlocks';
import { BasicNotifications } from '../components/NotificationComponent';
import IWidgetBlock, { ConfigBlockState, IWidgetBlockComponent, WidgetState } from '../WidgetBlocks/types/IWidgetBlock';
import WidgetBlockWrapper from './WidgetBlockWrapper';

class WidgetBlockWrapperComponent extends React.Component<IWidgetBlockComponent, { hasError: boolean }> {
    constructor(props: IWidgetBlockComponent) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        this.setState({ hasError: true });

        console.warn(error, info, this.props);
    }

    render() {
        const { widgetId, instanceId, notifications, fireNotificationDismissed } = this.props;
        const widget: IWidgetBlock<ConfigBlockState, WidgetState> | null = widgetId ? widgetBlocksDefinitions[widgetId] : null;
        const WidgetBlock = widget?.widgetBlock;

        if (this.state.hasError || !WidgetBlock) {
            let message = `Widget of type ${widgetId} not found`;

            if (this.state.hasError) {
                message = `We encountered an error when attempting to display the information in this ${widget?.label || 'component'}.`;
            }

            return (
                <div className='ant-d-name-space'>
                    <Alert style={{ height: '100%' }} message={message} type='error' showIcon />
                </div>
            );
        }

        return (
            <div className='ant-d-name-space' style={{ width: '100%', height: '100%' }}>
                <BasicNotifications notifications={notifications} fireNotificationDismissed={fireNotificationDismissed} notificationsShouldBeHandled={false} />
                <WidgetBlock widgetId={widgetId} instanceId={instanceId} />
            </div>
        );
    }
}

export default WidgetBlockWrapper(WidgetBlockWrapperComponent);
